import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createProduct, CreateProductPayload } from '../api/createProduct';

export const useCreateProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateProductPayload) => {
      return await createProduct(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products-all'] });
    }
  });
};
